import React, { useState } from 'react';
import IMAGES from '../config/images';

export default function Custom() {
  const [form, setForm] = useState({ name:'', email:'', phone:'', size:'', material:'', colors:'', desc:'' });
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e) => { e.preventDefault(); setSubmitted(true); };
  const u = (k,v) => setForm({...form,[k]:v});

  return (
    <div style={{ background:'#fbfaee' }}>
      {/* Hero */}
      <section className="cu-hero">
        <div className="cu-hero-bg" style={{ backgroundImage:`url("${IMAGES.hero}")` }}></div>
        <div className="cu-hero-ov"></div>
        <div className="cu-hero-ct">
          <span className="cu-lbl" style={{ color:'#f7bd48' }}>BESPOKE SERVICE</span>
          <h1 className="cu-hero-t">Your Vision,<br/>Our Craft</h1>
          <p className="cu-hero-s">Commission a one-of-a-kind handcrafted rug tailored to your exact specifications — size, color, pattern, and material.</p>
        </div>
      </section>

      {/* How it works */}
      <section style={{ padding:'80px 60px', background:'#f5f4e8' }}>
        <div style={{ textAlign:'center', marginBottom:50 }}>
          <span className="cu-lbl">THE PROCESS</span>
          <h2 className="cu-h2">How Custom Orders Work</h2>
        </div>
        <div className="cu-steps">
          {[
            { n:'01', t:'Consultation', d:'Share your vision — size, colors, pattern, material. We guide you through options.' },
            { n:'02', t:'Design & Approval', d:'Our designers create a detailed rendering for your review and approval.' },
            { n:'03', t:'Handcrafting', d:'Master weavers bring your design to life. Typical timeline: 8-12 weeks.' },
            { n:'04', t:'Delivery', d:'White-glove delivery to your doorstep with quality certificate included.' },
          ].map((s,i) => (
            <div key={i} className="cu-step">
              <span className="cu-step-n">{s.n}</span>
              <h3 className="cu-step-t">{s.t}</h3>
              <p className="cu-step-d">{s.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Options */}
      <section style={{ padding:'80px 60px' }}>
        <div style={{ textAlign:'center', marginBottom:50 }}>
          <span className="cu-lbl">CUSTOMIZE EVERYTHING</span>
          <h2 className="cu-h2">Your Options</h2>
        </div>
        <div className="cu-opts">
          {[
            { icon:'📐', t:'Any Size', d:'From 2x3 ft to room-sized 12x18 ft. Custom dimensions available.' },
            { icon:'🎨', t:'Custom Colors', d:'Match any Pantone shade. Natural and synthetic dye options.' },
            { icon:'🧵', t:'Material Choice', d:'Wool, silk, cotton, jute, or blends. Each selected for your need.' },
            { icon:'🔲', t:'Pattern Design', d:'Traditional, modern, geometric, or your own uploaded design.' },
          ].map((o,i) => (
            <div key={i} className="cu-opt">
              <span style={{ fontSize:32, display:'block', marginBottom:14 }}>{o.icon}</span>
              <h3 className="cu-opt-t">{o.t}</h3>
              <p className="cu-opt-d">{o.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Form */}
      <section style={{ padding:'80px 60px', background:'#1b1c15' }}>
        <div className="cu-form-wrap">
          <div className="cu-form-info">
            <span className="cu-lbl" style={{ color:'#f7bd48' }}>START YOUR PROJECT</span>
            <h2 className="cu-h2" style={{ color:'#fff' }}>Request a Custom Order</h2>
            <p style={{ color:'rgba(255,255,255,.6)', fontSize:14, lineHeight:1.8, marginBottom:30 }}>
              Share your requirements and our design team will get back to you within 48 hours with options and pricing.
            </p>
            <p style={{ color:'rgba(255,255,255,.5)', fontSize:13 }}>📧 support@kaaleenhaus.com</p>
            <p style={{ color:'rgba(255,255,255,.5)', fontSize:13 }}>📞 +49 15567406041</p>
          </div>
          <div className="cu-form-box">
            {submitted ? (
              <div style={{ textAlign:'center', padding:'60px 20px', color:'#785600' }}>
                <span style={{ fontSize:48 }}>✓</span>
                <h3 style={{ fontFamily:"'Noto Serif',serif", fontSize:'1.4rem', margin:'16px 0 8px', color:'#1b1c15' }}>Request Submitted!</h3>
                <p style={{ fontSize:14, color:'#4f4535' }}>Our design team will contact you within 48 hours.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="cu-row">
                  <input placeholder="Full Name *" required value={form.name} onChange={e=>u('name',e.target.value)} />
                  <input placeholder="Email *" type="email" required value={form.email} onChange={e=>u('email',e.target.value)} />
                </div>
                <div className="cu-row">
                  <input placeholder="Phone" value={form.phone} onChange={e=>u('phone',e.target.value)} />
                  <input placeholder="Desired Size (e.g. 8x10 ft)" value={form.size} onChange={e=>u('size',e.target.value)} />
                </div>
                <div className="cu-row">
                  <select value={form.material} onChange={e=>u('material',e.target.value)}>
                    <option value="">Select Material</option>
                    <option>Wool</option><option>Wool & Silk</option><option>Pure Silk</option><option>Cotton</option><option>Jute</option>
                  </select>
                  <input placeholder="Preferred Colors" value={form.colors} onChange={e=>u('colors',e.target.value)} />
                </div>
                <textarea placeholder="Describe your vision — pattern, style, room context..." rows="4" value={form.desc} onChange={e=>u('desc',e.target.value)}></textarea>
                <button type="submit" className="cu-submit">Submit Request</button>
              </form>
            )}
          </div>
        </div>
      </section>

      <style>{`
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif:wght@400;700&family=Inter:wght@300;400;500;600&display=swap');
.cu-lbl{display:block;font-family:Inter,sans-serif;font-size:11px;font-weight:600;letter-spacing:2.5px;text-transform:uppercase;color:#785600;margin-bottom:14px}
.cu-h2{font-family:'Noto Serif',Georgia,serif;font-size:2.4rem;font-weight:400;color:#1b1c15;margin:0 0 20px}
.cu-hero{position:relative;min-height:60vh;display:flex;align-items:center;justify-content:center;text-align:center;overflow:hidden}
.cu-hero-bg{position:absolute;inset:0;background-size:cover;background-position:center}
.cu-hero-ov{position:absolute;inset:0;background:rgba(27,28,21,.65)}
.cu-hero-ct{position:relative;z-index:2;max-width:650px;padding:0 20px}
.cu-hero-t{font-family:'Noto Serif',Georgia,serif;font-size:3.5rem;font-weight:400;color:#fff;margin:0 0 20px;line-height:1.1}
.cu-hero-s{font-family:Inter,sans-serif;color:rgba(255,255,255,.7);font-size:15px;line-height:1.8}
.cu-steps{display:grid;grid-template-columns:repeat(4,1fr);gap:30px;max-width:1100px;margin:0 auto}
.cu-step{background:#fff;padding:36px 28px;text-align:center}
.cu-step-n{font-family:'Noto Serif',serif;font-size:2.5rem;color:#d3c4af;display:block;margin-bottom:14px}
.cu-step-t{font-family:Inter,sans-serif;font-size:15px;font-weight:600;color:#1b1c15;margin:0 0 10px}
.cu-step-d{font-family:Inter,sans-serif;font-size:13px;color:#4f4535;line-height:1.7;margin:0}
.cu-opts{display:grid;grid-template-columns:repeat(4,1fr);gap:30px;max-width:1100px;margin:0 auto}
.cu-opt{text-align:center;padding:30px 20px;background:#f5f4e8;border-radius:4px}
.cu-opt-t{font-family:Inter,sans-serif;font-size:15px;font-weight:600;color:#1b1c15;margin:0 0 8px}
.cu-opt-d{font-family:Inter,sans-serif;font-size:13px;color:#4f4535;line-height:1.7;margin:0}
.cu-form-wrap{display:flex;gap:60px;max-width:1100px;margin:0 auto}
.cu-form-info{flex:1;padding-top:20px}
.cu-form-box{flex:1.2;background:#fff;padding:40px;border-radius:4px}
.cu-row{display:flex;gap:16px;margin-bottom:20px}
.cu-form-box input,.cu-form-box select,.cu-form-box textarea{width:100%;padding:14px 16px;border:none;border-bottom:1.5px solid #d3c4af;background:transparent;font-family:Inter,sans-serif;font-size:14px;outline:none;transition:border-color .3s;color:#1b1c15;box-sizing:border-box}
.cu-form-box select{appearance:none;cursor:pointer;color:#888}
.cu-form-box input:focus,.cu-form-box select:focus,.cu-form-box textarea:focus{border-bottom-color:#785600}
.cu-form-box textarea{resize:vertical;margin-bottom:24px}
.cu-submit{width:100%;padding:16px;background:linear-gradient(135deg,#785600,#986d00);color:#fff;border:none;font-family:Inter,sans-serif;font-size:13px;font-weight:600;letter-spacing:2px;text-transform:uppercase;cursor:pointer;border-radius:4px}
@media(max-width:900px){.cu-steps,.cu-opts{grid-template-columns:repeat(2,1fr)}.cu-form-wrap{flex-direction:column}.cu-hero-t{font-size:2.4rem}}
@media(max-width:480px){.cu-steps,.cu-opts{grid-template-columns:1fr}.cu-row{flex-direction:column;gap:0}.cu-row input,.cu-row select{margin-bottom:20px}}
      `}</style>
    </div>
  );
}
